<script>
import { Role } from "@/router/role";

export default {
  name: "nav",

  data() {
    return {

      // + Role based authorization

      allItems: [
        //#region Dashboard
        {
          _name: "CSidebarNavItem",
          name: "Dashboard",
          to: "/dashboard",
          icon: "cil-speedometer",
        },
        {
          _name: "CSidebarNavItem",
          name: "Billing Entities",
          to: { name: "Billing Entities" },
          icon: "cil-building",
          authorize: [Role.SuperAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Activities",
          to: "/activities",
          icon: "cil-fingerprint",
          authorize: [Role.SuperAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Delivery Service",
          to: { name: "DeliveryServiceDashboard" },
          authorize: [Role.SuperAdmin, Role.Admin, Role.CourierAdmin],
          icon: {
            name: 'cil-truck',
            class: 'text-info'
          },
          // badge: {
          //   color: 'info',
          //   text: 'NEW ➔',
          //   shape: 'pill'
          // }
        },
        //#endregion

        //#region + User Management
        {
          _name: "CSidebarNavTitle",
          _children: ["User Management"],
          authorize: [Role.SuperAdmin, Role.Admin],
        },
        {
          _name: "CSidebarNavItem",
          name: "All Users",
          to: { name: "All Users" },
          icon: "cil-group",
          authorize: [Role.SuperAdmin, Role.Admin],
        },
        {
          _name: "CSidebarNavItem",
          name: "User Devices",
          to: { name: "UserDevices" },
          icon: "cil-mobile",
          authorize: [Role.SuperAdmin, Role.Admin],
        },
        {
          _name: "CSidebarNavItem",
          name: "VoIP Accounts",
          to: { name: "VoIPAccounts" },
          icon: "cil-headphones",
          authorize: [Role.SuperAdmin]
        },
        //#endregion

        //#region + CRM
        {
          _name: "CSidebarNavTitle",
          _children: ["CRM"],
          notAuthorize: [Role.TotalViewerBelgium],
        },
        {
          _name: "CSidebarNavItem",
          name: "Task List",
          to: { name: "Task List" },
          icon: "cil-bolt",
          notAuthorize: [Role.TotalViewerBelgium],
        },
        {
          _name: "CSidebarNavItem",
          name: "CRM Reports",
          to: { name: "CRM Reports" },
          icon: "cil-notes",
          notAuthorize: [Role.TotalViewerBelgium],
        },
        {
          _name: "CSidebarNavItem",
          name: "Email",
          to: { name: "Email" },
          icon: "cil-at",
          notAuthorize: [Role.TotalViewerBelgium],
        },
        {
          _name: "CSidebarNavItem",
          name: "Messages",
          to: { name: "Message List" },
          icon: "cil-chat-bubble",
          authorize: [Role.SuperAdmin],
        },
        //#endregion

        //#region + Contents
        {
          _name: "CSidebarNavTitle",
          _children: ["Contents"],
          authorize: [Role.SuperAdmin, Role.Admin, Role.MenuAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Menu Scraper",
          to: { name: "Menu Scraper" },
          icon: "cil-vertical-align-bottom",
          authorize: [Role.SuperAdmin, Role.Admin, Role.MenuAdmin]
        },
        // {
        //   // Menu Groups
        //   _name: "CSidebarNavItem",
        //   name: "Menu Groups",
        //   to: { name: "Menu Groups" },
        //   icon: "cil-object-group",
        //   authorize: [Role.SuperAdmin, Role.Admin, Role.MenuAdmin]
        // },
        // {
        //   // Menu Sjabloons
        //   _name: "CSidebarNavItem",
        //   name: "Menu Sjabloons",
        //   to: { name: "Menu Sjabloons" },
        //   icon: "cil-object-ungroup",
        //   authorize: [Role.SuperAdmin, Role.Admin, Role.MenuAdmin]
        // },
        {
          // Images
          _name: "CSidebarNavItem",
          name: "Images",
          to: { name: "Images" },
          icon: "cil-image",
          authorize: [Role.SuperAdmin, Role.Admin, Role.MenuAdmin]
        },
        {
          // Vouchers
          _name: "CSidebarNavItem",
          name: "Vouchers",
          to: { name: "Vouchers" },
          icon: "cil-money",
          authorize: [Role.SuperAdmin]
        },
        //#endregion

        //#region + Restaurants
        {
          _name: "CSidebarNavTitle",
          _children: ["Restaurants"],
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Restaurants",
          to: { name: "Restaurants" },
          icon: "cil-restaurant",
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Delivery Zones",
          to: { name: "Delivery Zones" },
          icon: "cil-location-pin",
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Map",
          to: { name: "All Restaurants On Map" },
          icon: "cil-map",
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Types",
          to: { name: "Restaurant Types" },
          icon: "cil-text",
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Devices",
          to: { name: "Devices" },
          icon: "cil-mobile",
          authorize: [Role.SuperAdmin, Role.Admin, Role.RestAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Reviews",
          to: { name: "Reviews" },
          icon: "cil-star",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "DNS Management",
          to: { name: "DnsManagement" },
          icon: "cil-cloud",
          authorize: [Role.SuperAdmin]
        },
        //#endregion

        //#region + Orders
        // {
        //   _name: 'CSidebarNavDivider',
        //   _class: 'my-2'
        // },
        {
          _name: "CSidebarNavTitle",
          _children: ["Orders"],
          authorize: [Role.SuperAdmin, Role.Admin, Role.OrderAdmin, Role.RestAdmin, Role.Representative, Role.InvoiceAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Order List",
          to: { name: "Order List" },
          icon: "cil-cart",
          authorize: [Role.SuperAdmin, Role.Admin, Role.OrderAdmin, Role.RestAdmin, Role.Representative]
        },
        {
          _name: "CSidebarNavItem",
          name: "Merchandise Orders",
          to: { name: "Merchandise Orders" },
          icon: "cil-library",
          authorize: [Role.SuperAdmin, Role.Admin, Role.OrderAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Invoices",
          to: { name: "Invoice List" },
          icon: "cil-file",
          authorize: [Role.SuperAdmin, Role.Admin, Role.InvoiceAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Manual Invoices",
          to: { name: "Manual Invoice List" },
          icon: "cil-pencil",
          authorize: [Role.SuperAdmin, Role.Admin, Role.InvoiceAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Payments",
          to: { name: "Payment List" },
          icon: "cil-euro",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Bank Transactions",
          to: { name: "Bank Transactions" },
          icon: "cil-transfer",
          authorize: [Role.SuperAdmin, Role.Admin, Role.InvoiceAdmin]
        },
        //#endregion

        //#region + MenutePay
        {
          _name: "CSidebarNavTitle",
          _children: ["MenutePay"],
          authorize: [Role.SuperAdmin, Role.Admin, Role.InvoiceAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Companies",
          to: { name: "Companies" },
          icon: "cil-building",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Invoices",
          to: { name: "MenutePay Invoices" },
          icon: "cil-file",
          authorize: [Role.SuperAdmin, Role.Admin, Role.InvoiceAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Internal Settlements",
          to: { name: "MenutePay Internal Settlements" },
          icon: "cil-library",
          authorize: [Role.SuperAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Payments",
          to: { name: "MenutePay Payments" },
          icon: "cil-euro",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Users",
          to: { name: "MenutePay Users" },
          icon: "cil-group",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        //#endregion

        //#region + Reports
        {
          _name: "CSidebarNavTitle",
          _children: ["Reports"],
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Revenue",
          to: { name: "Revenue" },
          icon: "cil-chart-line",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Average Order Reports",
          to: { name: "OrderReports" },
          icon: "cil-chart-pie",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Invoices",
          to: { name: "InvoiceReport" },
          icon: "cil-file",
          authorize: [Role.SuperAdmin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Customer Analysis",
          to: { name: "CustomerAnalysis" },
          icon: "cil-lightbulb",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Representative Reports",
          to: { name: "RepresentativeRestaurantReport" },
          icon: "cil-people",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Ad Clicks",
          to: { name: "AdClickReport" },
          icon: "cil-touch-app",
          authorize: [Role.SuperAdmin]
        },
        //#endregion

        //#region + Settings
        {
          _name: "CSidebarNavTitle",
          _children: ["Settings"],
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        {
          _name: "CSidebarNavItem",
          name: "Holidays",
          to: { name: "Holidays" },
          icon: "cil-header",
          authorize: [Role.SuperAdmin, Role.Admin]
        },
        //#endregion
      ]
    };
  },

  computed: {
    currentItems() {
      return this.allItems.filter((item) => {
        return !(item.notAuthorize && item.notAuthorize.some((role) => this.authUserRoles.includes(role))) &&
        (!item.authorize || item.authorize.some((role) => this.authUserRoles.includes(role)))
      });
    },

    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: this.currentItems,
        },
      ];
    },
  },
};
</script>

